<template>
    <Modal2
        title=""
        :visible="true"
        @cancel="closeModal"
        class="voice-assistant-modal"
        @ok="closeModal"
    >
        <template v-slot:title>
            <div class="d-flex gap-5 title">
                <img src="/static/img/copilot.png" />
                <h2>{{ $t("ticket.thisPageVoiceAssistant")}}</h2>
            </div>
        </template>
        <div class="voice-assistant-content">
            <h2>{{ $t("ticket.hello") }} {{ user.name }} 👋</h2>
            <p v-html="translatedMessage"></p>
            <ul>
                <li><strong>CTRL + "</strong> {{ $t("ticket.commandHoldingDownTheKey") }}</li>
                <li>
                    {{ $t("ticket.topRightContent") }} <img src="/static/img/copilot.png" width="40" height="40" /> {{ $t("ticket.clickOnTheIcon") }}
                </li>
            </ul>
            <div class="manual-main-content">
                <div class="voice-commands">
                    <h3>{{ $t("ticket.sampleVoiceCommands") }}</h3>
                    <ul>
                        <li>"{{$t("ticket.showMyTickets")}}"</li>
                        <li>"{{$t("ticket.showMeZeynepsOpenTicket")}}"</li>
                        <li>"{{$t("ticket.deleteTicketsScreen")}}"</li>
                        <li>"{{$t("ticket.assigntLastTicketAli")}}"</li>
                        <li>"{{$t("ticket.changeStatusAllTicket")}}"</li>
                        <li>"{{$t("ticket.setStatusTicketsScreen")}}"</li>
                        <li>"{{$t("ticket.assigntUserTicketScreen")}}"</li>
                        <li>"{{$t("ticket.assigntFirstTicket")}}"</li>
                        <li>"{{$t("ticket.showIgTickets")}}"</li>
                    </ul>
                </div>
                <img src="https://static.supsis.live/common/image/ticket-copilot.gif" />
            </div>
            <div class="assistant-animation">
                <!-- Animasyon veya görsel içerik buraya gelebilir -->
            </div>
        </div>
    </Modal2>
</template>
<script>
import Vue from "vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import { mapState } from "vuex";

export default Vue.extend({
    name: "TicketVoiceAssistantManual",
    components: {
        Modal2,
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        translatedMessage() {
            return this.$t('ticket.voiceAssistantContent');
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>
<style scoped lang="scss">
.voice-assistant-modal {
    .voice-assistant-content {
        text-align: center;

        h2 {
            font-size: 24px;
            margin-bottom: 20px;
        }

        p {
            font-size: 16px;
            margin-bottom: 20px;
        }

        ul {
            list-style: none;
            padding: 0;

            li {
                font-size: 16px;
                margin: 10px 0;

                i {
                    margin-right: 8px;
                }
            }
        }

        .voice-commands {
            background-color: #f0f8ff;
            padding: 20px;
            border-radius: 8px;
            margin: 20px 0;

            h3 {
                font-size: 20px;
                margin-bottom: 10px;
            }

            ul {
                li {
                    font-size: 16px;
                    margin: 5px 0;

                    &:before {
                        content: "🔹";
                        margin-right: 8px;
                    }
                }
            }
        }

        .assistant-animation {
            margin-top: 20px;

            img {
                max-width: 100%;
                height: auto;
            }
        }
    }
}
</style>
<style lang="scss">
.voice-assistant-modal {
    .ant-modal {
        width: 90vw !important;
    }

    .title {
        font-weight: 700;
        color: var(--color-text-strong-default);
        font-size: 24px;
        line-height: 32px;
        display: flex;
        align-items: center;
        gap: 5px;

        h2 {
            margin: 0 !important;
        }

        img {
            width: 40px;
            height: 40px;
        }
    }

    .manual-main-content {
        display: flex;
        gap: 20px;
    }
}
</style>
